//Blocchi - structure: [name,img,[array of links]]    // if 1 link => direct link, otherwise overlay to choose between SMART (the first) and STANDARD (the second)
var base_path="https://configurator.creative-cables.com/customize";
var subfolder="assets_new_landing";
var title="Que voulez-vous configurer?";
var smart="Configurez maintenant la version SMART";
var standard="Configurez maintenant la version STANDARD";
let lampade_da_soffitto = [
                                 ["Suspension simple",base_path+"/"+subfolder+"/img/grid/214.svg",[base_path+"/frontend.php?id_model=214"]],
                                 ["Suspension 2 chutes",base_path+"/"+subfolder+"/img/grid/212.svg",[base_path+"/frontend.php?id_model=212"]],
                                 ["Suspension 3 chutes",base_path+"/"+subfolder+"/img/grid/292.svg",[base_path+"/frontend.php?id_model=292"]],
                                 ["Suspension 4 chutes",base_path+"/"+subfolder+"/img/grid/285.svg",[base_path+"/frontend.php?id_model=285"]],
                                 ["Rose-One 2 chutes",base_path+"/"+subfolder+"/img/grid/213.svg",[base_path+"/frontend.php?id_model=213"]],
                                 ["Rose-One 3 chutes",base_path+"/"+subfolder+"/img/grid/233.svg",[base_path+"/frontend.php?id_model=233"]],
                                 ["Rose-One 4 chutes",base_path+"/"+subfolder+"/img/grid/235.svg",[base_path+"/frontend.php?id_model=235"]],                            
                                 ["Spot pour rail",base_path+"/"+subfolder+"/img/grid/333.svg",[base_path+"/frontend.php?id_model=333"]],
                                 ];
let lampade_da_parete = [
                             ["Fermaluce",base_path+"/"+subfolder+"/img/grid/222.svg",[base_path+"/frontend.php?id_model=222"]],
                             ["Fermaluce avec articulation",base_path+"/"+subfolder+"/img/grid/223.svg",[base_path+"/frontend.php?id_model=223"]],
                             ["Fermaluce avec extension en L",base_path+"/"+subfolder+"/img/grid/224.svg",[base_path+"/frontend.php?id_model=224"]],
                             ["Fermaluce avec extension en S",base_path+"/"+subfolder+"/img/grid/128.svg",[base_path+"/frontend.php?id_model=128"]],
                             ["Lampe magnétique avec articulation",base_path+"/"+subfolder+"/img/grid/316.svg",[base_path+"/frontend.php?id_model=316"]],
                             ];

let lampade_da_tavolo = [
                            ["Posaluce",base_path+"/"+subfolder+"/img/grid/266.svg",[base_path+"/frontend.php?id_model=266"]],
                            ["Posaluce avec articulation",base_path+"/"+subfolder+"/img/grid/267.svg",[base_path+"/frontend.php?id_model=267"]],
                            ["Posaluce avec Flex",base_path+"/"+subfolder+"/img/grid/258.svg",[base_path+"/frontend.php?id_model=258"]],
                            ["Cubetto",base_path+"/"+subfolder+"/img/grid/221.svg",[base_path+"/frontend.php?id_model=221"]],
                            ["Tache",base_path+"/"+subfolder+"/img/grid/225.svg",[base_path+"/frontend.php?id_model=225"]],
                            ["Materia",base_path+"/"+subfolder+"/img/grid/226.svg",[base_path+"/frontend.php?id_model=226"]],
                        ];

let lampade_plug_in = [
                             ["Lampe avec prise",base_path+"/"+subfolder+"/img/grid/231.svg",[base_path+"/frontend.php?id_model=231"]],
                             
                        ];


let cablaggi = [
                             ["C\u00E2blage",base_path+"/"+subfolder+"/img/grid/237.svg",[base_path+"/frontend.php?id_model=238"]],
                             ];

let rosoni = [
                             ["Pavillons XXL",base_path+"/"+subfolder+"/img/grid/330.svg",[base_path+"/frontend.php?id_model=329"]],
                             ];


//Menu - structure: [name,img,anchor, product list (above)]
let l=[
    ["Lampes de plafond","","lampade-da-soffitto",lampade_da_soffitto],
    ["Lampes murales","","lampade-da-parete",lampade_da_parete],
    ["Lampes de table","","lampade-da-tavolo",lampade_da_tavolo],
    ["Lampes avec prise","","lampade-plugin",lampade_plug_in],
    ["C\u00E2blages","","cablaggi",cablaggi],
    ["Pavillons","","rosoni",rosoni],
    
];